<template>
    <div id="exhibition-page-container">
        
        <div id="exhibition-text-container" @click="showExhibitionText">
            <!--<h2>Duality</h2>-->
            <!--Yeni eklenen yer başlangıç-->
            <h2>{{ exhibitionName }}</h2>
            <!--Yeni eklenen yer bitiş-->
            <h3> <i class="fa-solid fa-file-lines fa-1x"></i> {{ $t('exhibitionPage.exhibitionText') }}</h3>
        </div>

        <div id="exhibition-works-images-container">
            <!--Yapılan değişiklik imageInfoList, imageInfoListFiltered olarak değişti-->
            <div v-for="(imageInfo, index) in imageInfoListFiltered" :key="imageInfo.imageName" class="image-container">
                <img :src="getImagePath(imageInfo.imageName)" :alt="imageInfo.imageName" @click="openOverlay(index)">
            </div>
        </div>

        <!--Exhibition Text Modal-->
        <div v-if="isModalVisible" class="modal-overlay" @click="closeExhibitionText">
            <div class="modal-content" @click.stop>
                <!-- X Butonu -->
                <!-- <button class="close-button" @click="closeExhibitionText"><span>✖</span></button> -->
                <button class="close-button" @click="closeExhibitionText"><span>X</span></button>

                <!--<h2 style="color: rgb(27, 27, 27);">Exhibition Text</h2>-->
                <!--Yeni eklenen yer başlangıç-->
                <h2 style="color: rgb(27, 27, 27);">{{ $t('exhibitionPage.exhibitionText') }}</h2>
                <!--Yeni eklenen yer bitiş-->

                <div class="modal-body">
                    <!--Burası yorum satırına alındı i18n için-->
                    <!--
                    <p>
                        In his productions, Serdar Kaynak focused on elements such as duality, duality, and dual balance, 
                    especially in terms of the subjects he dealt with. We see that his work has been faithful to madness 
                    in its creation and practice, transforming them from imaginary realities into objective realities without forcing them.
                    <br><br>
                    He has set up the form approaches of his productions in this direction and tried to create it as a sure that completes 
                    his journey of contrast in nature and the universe. He believed in duality, in every aspect of life, and formally questioned 
                    the dilemma journey in terms of opposition-contrast. Combining the issues that are considered internally in the essence, 
                    in the form of meanings and in the content, the contrast did not shape the opposition with an emotional approach 
                    that could accumulate the contextual evaluations.
                    <br><br>
                    Most of their productions can be interpreted as productions in which a strong sense of form is at the forefront.
                    <br><br>
                    People who say art is the change and transformation trials that are affected by the continuity of life,
                    and who move into objects within the subjects dealt with, are the clues of both the inner world and the stance in life.
                    As a result of the contrasts captured by the artist, the subject is understood forever as mutual explanations, 
                    a movement that ends time, and a restriction-separation dilemma.
                    <br><br>
                    He emphasizes the importance and content of his work that is always on the ground, by saying that 
                    art should always win, with a mindset that cares about applications within the limitlessness of 
                    new searches and practices that will add immanence to their production.
                    <br><br>
                    The point of view of art as a language and expression development defends the point of view of 
                    the periods according to the development and production perspectives that the artist can show without repetition.
                    <br>
                    </p>
                    -->

                    <!--Yeni eklenen yer başlangıç-->
                    <p class="multiline-text">{{ exhibitionInfo }}</p>
                    <!--Yeni eklenen yer bitiş-->
                </div>
                <!-- <button class="close-modal-button" @click="closeExhibitionText">Close</button> -->
            </div>
        </div>

        <!-- Overlay -->
        <div v-if="isOverlayVisible" class="overlay" @click="closeOverlay">
            <div class="overlay-content" @click.stop>
                <button class="btn" @click="prevImage">
                    <p> ❮ </p>
                </button>

                <div class="overlay-image-container">
                    <!--Yapılan değişiklik imageInfoList, imageInfoListFiltered olarak değişti-->
                    <!--
                    <img 
                    :src="getImagePath(imageInfoList[currentImageIndex].imageName)" 
                    :alt="imageInfoList[currentImageIndex].imageName" 
                    class="overlay-image">
                    -->
                    <img 
                    :src="getImagePath(imageInfoListFiltered.at(currentImageIndex).imageName)" 
                    :alt="imageInfoListFiltered.at(currentImageIndex).imageName" 
                    class="overlay-image">
                
                    <div class="work-info">
                        <!--Yapılan değişiklik imageInfoList, imageInfoListFiltered olarak değişti-->
                        <p>
                            <!-- {{ getImageInfo(imageInfoListFiltered.at(currentImageIndex).imageName) }} -->
                            {{ imageInfoListFiltered.at(currentImageIndex).imageInfo }}
                        </p>
                    </div>
                </div>
                
                <button class="btn" @click="nextImage">
                   <p> ❯ </p> 
                </button>
            </div>
        </div>


    </div>
</template>

<script>
//import axios from 'axios';
import { useExhibitionPageStore } from '../stores/exhibitionPageStore';

export default{
    data(){
        return{
            store: useExhibitionPageStore(),
            isOverlayVisible: false,
            currentImageIndex: null, // Hangi resme tıklanacağını tutacak
            isModalVisible: false,
            //yeni kaldırılan yer başlangıç
            //imageInfoList: [] // API'den gelen bilgileri tutacak
            //yeni kaldırılan yer bitiş
        }
    },
    computed: {
        imageInfoListFiltered() {
            return this.store.filteredImages;
        },
        exhibitionName() {
            return this.store.exhibitionNameFiltered;
        },
        exhibitionInfo() {
            return this.store.exhibitionInfoFiltered;
        }
    },
    methods:{
        showExhibitionText(){
            this.isModalVisible = true;
        },
        closeExhibitionText(){
            this.isModalVisible = false;
        },
        getImagePath(fileName) {
            return `/exhibition-images/${fileName}`;
        },
        openOverlay(index) {
            this.currentImageIndex = index;
            this.isOverlayVisible = true; // Overlay'i göster
        },
        closeOverlay() {
            this.isOverlayVisible = false; // Overlay'i kapat
        },
        prevImage(){
            if (this.currentImageIndex === 0) {
                // İlk resimden önceki resme geçiş: Son resme git
                //this.currentImageIndex = this.imageInfoList.length - 1;
                //this.currentImageIndex = this.store.dsata.length - 1;
                this.currentImageIndex = this.imageInfoListFiltered.length - 1;
            } else {
                // Önceki resme geç
                this.currentImageIndex--;
            }
        },
        nextImage(){
            //if (this.currentImageIndex === this.imageInfoList.length - 1) {
            //if (this.currentImageIndex === this.store.data.length - 1) {
            if (this.currentImageIndex === this.imageInfoListFiltered.length - 1) {
                // Son resimden sonraki resme geçiş: İlk resme git
                this.currentImageIndex = 0;
            } else {
                // Sonraki resme geç
                this.currentImageIndex++;
            }
        },
        //yeni eklenen yer başlangıç
        getImageInfo(fileName) {
            const image = this.store.data.find(img => img.imageName === fileName)
            return image ? image.imageInfo : 'No information'
        },
        //yeni eklenen yer bitiş
        //yeni kaldırılan yer başlangıç
        /*async fetchImageInfo() {
            try {
                const response = await axios.get("/api/exhibition/get-images");
                this.imageInfoList = response.data; // API'den gelen bilgileri atıyoruz
            } catch (error) {
                console.error("API call failed:", error);
            }
        },*/
        //yeni kaldırılan yer bitiş
    },
    async created(){
        // API'den image bilgilerini al

        //yeni kaldırılan yer başlangıç
        /*await this.fetchImageInfo();*/
        //yeni kaldırılan yer bitiş

        //yeni eklenen yer başlangıç
        await this.store.fetchExhibitionData();
        //yeni eklenen yer bitiş
    }
}
</script>

<style scoped>
    #exhibition-page-container{
        width: 100vw;
        height: 100vh;
        padding: 0;
        margin: 0;

        border: 1px solid rgb(27, 27, 27); /*Arkaplan resmi gözükmemesi için konuldu. */
        background-color: rgb(27, 27, 27);

        display: flex;
        flex-direction: column;
        overflow: scroll;
    }

    #exhibition-text-container{
        margin-top: 1%;
        margin-left: 5%;
    }

    h3{
        color: rgba(245, 245, 245);
        cursor: pointer;
    }

    h2{
        color: rgba(245, 245, 245);
    }

    #exhibition-works-images-container{
        width: 90%;
        margin-top: 1%;
        margin-left: 5%;

        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-evenly;
    }

    .image-container{
        width: 250px; 
        height: 300px;
        border-radius: 1%;
        padding: 0%;  
        margin-bottom: 5%;   
    }

    .image-container img{
        width: 250px; 
        height: 300px; 
        margin: auto;
        object-fit: contain;
        border-radius: 1%;
        cursor: pointer;
    }

    /* Overlay */
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .overlay-content {
        position: relative;
        width: auto;
        border: 1%;
        border-radius: 1%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .overlay-image-container{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .btn{
        width: 30px;
        background: none;
        border: none;
        cursor: pointer;
    }

    .btn p{
        font-size: 20px;
        font-weight: 900;
        color: white;
    }

    .work-info p{
        max-width: 390px;
        color: white;
    }

    .overlay-image {
        width: 450px;
        height: 525px;
        object-fit: contain;
        margin-left: 0px;
        padding: 0px;
    }

    /* Modal 2 CSS*/
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 2000;
    }

    .modal-content {
        background: rgba(255, 255, 255, 0.9);
        padding: 20px;
        border-radius: 8px;
        width: 50%;
        max-height: 80%; /* Maksimum yükseklik */
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
        position: relative; /* "X" butonu için */
        display: flex;
        flex-direction: column;
    }

    .modal-content h2 {
        margin-bottom: 10px;
        text-align: center;
    }

    .modal-body {
        overflow-y: auto; /* Kaydırma özelliği */
        max-height: 300px; /* İçerik yüksekliği */
        margin-bottom: 20px;
        text-align: left;
    }

    .modal-content button {
        padding: 10px 20px;
        background-color: rgb(27, 27, 27);
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        align-self: center; /* Ortaya hizalar */
    }

    .modal-content button:hover {
        background-color: rgb(3, 3, 3);
    }

    .close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: none;
        border: none;
        font-size: 15px;
        font-weight: bold;
        background-color: rgb(27, 27, 27);
        color: white;
        cursor: pointer;
    }

    .close-button:hover {
        background-color: rgb(3, 3, 3);
    }

    .multiline-text {
        white-space: pre-line;
    }

    /* Mobil Cihazlar İçin */
    @media (max-width: 768px) {
        /* Overlay */
        .overlay-image{
            width: 340px;
        }

        /* Modal */
        .modal-content{
            width: 70%;
        }
        .modal-content button{
            padding: 0;
            width: 25px;
            height: 25px;
            color: white;
        }

        .close-button span{
            color: white;
            font-weight: 900;
            margin: auto;
        }
    }

</style>